/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import { Box, Typography, Link as MuiLink } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import { useProfileByProfileIdQuery } from "queries/useProfileByProfileIdQuery";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { AuthFormWrapper } from "components/authentication/AuthFormWrapper";
import { LoginForm } from "components/authentication/login";

import { ROUTES } from "constants/routes";
import useAuth from "hooks/useAuth";

const Login: React.FC = () => {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const router = useRouter();
  const hasProfileId = Boolean(user?.profile_id);
  const { data: profile, loading: profileLoading } = useProfileByProfileIdQuery(
    {
      variables: { profileId: user?.profile_id ?? "" },
      skip: !hasProfileId,
    }
  );

  React.useEffect(() => {
    /*
     * Wait for a definitive answer on the plan before deciding: on first
     * render `profile` is still undefined (the query hasn't resolved, or
     * hasn't even started yet without a profile_id), which looked
     * indistinguishable from "no plan" and sent every first_login account
     * straight to plan-selection — even ones with a real subscription.
     */
    if (!hasProfileId || profileLoading) return;
    if (user?.first_login && !profile?.profileByProfileId.plan) {
      router.push(ROUTES.REGISTER_PLAN_SELECTION);
    } else if (user?.first_login === false) {
      router.push(ROUTES.DASHBOARD);
    }
  }, [user, router, profile, profileLoading, hasProfileId]);

  return (
    <AuthFormWrapper title="Login">
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <LoginForm />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          columnGap: 0.5,
          mt: 3,
        }}
      >
        <Typography
          color="textSecondary"
          variant="body1"
          style={{ fontSize: "1rem" }}
        >
          {i18n.t("login.no_account") as string}
        </Typography>
        <Link href={ROUTES.AUTH_CREATE_ACCOUNT} passHref>
          <MuiLink sx={{ p: 0 }} style={{ fontSize: "1rem" }}>
            {i18n.t("login.sign_up") as string}
          </MuiLink>
        </Link>
      </Box>
    </AuthFormWrapper>
  );
};
export default Login;
